import React from 'react';

interface UserFormProps {
  heading?: string;
  message?: React.ReactNode;
}

const ModalContent: React.FC<UserFormProps> = ({ heading, message }) => {
  return (
    <div>
      {heading ? (
        <h3 className="heading__title--info">{heading}</h3>
      ) : null}

      <div className="modal__message tooltip">
        {message ?? "Are you sure you want to delete this item?"}
      </div>
    </div>
  );
};

export { ModalContent };

